import * as React from 'react';
import {Trans} from '@lingui/macro';
import {useLingui} from '@lingui/react';

import Driver from 'driver.js';

import {Dialog, DialogOverlay, DialogContent} from '@reach/dialog';
import ButtonArrow from '../FerrariIcon/ButtonArrow';

import s from './FerrariTutorial.module.css';
import 'driver.js/dist/driver.min.css';
import '@reach/dialog/styles.css';

export default function FerrariTutorial({resetTutorial}) {
  const driverRef = useDriver({onReset: resetTutorial});

  const {i18n} = useLingui();

  React.useEffect(() => {
    startTutorial();
  }, []);

  function startTutorial() {
    const driver = driverRef.current;

    if (driver) {
      driver.defineSteps([
        {
          element: '#ferrari-progress-bar',
          popover: {
            className: s.FerrariTutorialPopover,
            title: 'Progress Bar',
            description:
              'This bar will start filling in as you complete tests, and eventually, sections, completing a section automatically takes you to the next. ',
            position: 'bottom',
          },
        },
        {
          element: '#ferrari-sub-header',
          popover: {
            title: 'Overview',
            description: 'This section allows you to see overall progress as you keep going.',
            position: 'bottom',
          },
        },
        {
          element: '#ferrari-sub-header-progress',
          popover: {
            className: 'ferrari-tutorial-popover',
            title: 'Overview-Progress',
            description:
              'Looking here you are easily able to see how far a long you are in the campaign.',
            position: 'bottom',
          },
        },
        {
          element: '#ferrari-sub-header-buttons',
          popover: {
            className: 'ferrari-tutorial-popover',
            title: 'Useful Links',
            description:
              'To rewatch the tutorial, you can click the watch tutorial button, or you can look at some interesting things about Ferrari.',
            position: 'left',
          },
        },
        {
          element: '#ferrari-review-docs',
          popover: {
            className: 'ferrari-tutorial-popover',
            title: 'Ferrari Links',
            description:
              "Clicking this button you'll be transported to an area where you'll have access to lots of important information about Ferrari, we highly suggest taking a look",
            position: 'left',
          },
        },
        {
          element: '#ferrari-rewatch',
          popover: {
            className: 'ferrari-tutorial-popover',
            title: 'Rewatch Tutorial',
            description:
              'If you missed something in the tutorial, click here to start it again, make sure you understand how to use the platform',
            position: 'left',
          },
        },
        {
          element: '#ferrari-section',
          popover: {
            className: 'ferrari-tutorial-popover',
            title: 'Section Information',
            description:
              'Here you will be able to see some general information about the current section, as well as the tests you must complete.',
            position: 'top',
          },
        },
        {
          element: '#ferrari-section-description',
          popover: {
            className: 'ferrari-tutorial-popover',
            title: 'Section Description',
            description:
              'Looking here you will understand the scope of this section, as well as useful information as you go along.',
            position: 'top',
          },
        },
        {
          element: '#ferrari-section-cards',
          popover: {
            className: 'ferrari-tutorial-popover',
            title: 'Test Cards',
            description:
              'Each one of these cards represents a test, gray with yellow border means not attempted, full yellow means incomplete, and greyed out means completed',
            position: 'top',
          },
        },
        {
          element: '#ferrari-section-card-single',
          popover: {
            className: 'ferrari-tutorial-popover',
            title: 'Test Information',
            description: 'On each card you will find some useful information',
            position: 'top',
          },
        },
        {
          element: '#ferrari-section-card-read',
          popover: {
            className: 'ferrari-tutorial-popover',
            title: 'Read More',
            description:
              'We highly suggest clicking the read more button here to get some insight as to what is to come.',
            position: 'top',
          },
        },
        {
          element: '#ferrari-section-card-start',
          popover: {
            className: 'ferrari-tutorial-popover',
            title: 'Start',
            description:
              "Once you feel ready to start with a test, simply click on the start button, and you'll be transported to the test area",
            position: 'top',
          },
        },
      ]);

      driver.start();
    }
  }
  return null;
}

function useDriver({onReset}) {
  const tutorialDriverRef = React.useRef();

  React.useEffect(() => {
    tutorialDriverRef.current = new Driver({
      allowClose: false,
      opacity: 0.8,
      prevBtnText: 'Prev',
      stageBackground: 'rgba(255,255,255, .1)',
      animate: false,
      onReset,
    });
  }, []);

  return tutorialDriverRef;
}
